/* ==========================================================================
   BOCA — Frequently bought together
   Renders under Add to Bag on bundle-eligible products. The viewed product is
   always included; companions can be toggled and (where they have more than one
   variant) have a colour picker. Two companions start selected so the default
   set of three shows the 20% saving. The saving shown is a client-side estimate
   that mirrors the Shopify automatic discount (2 items = 10%, 3+ = 20%); the
   checkout remains authoritative. Everything is added as separate line items.
   ========================================================================== */
(function () {
  'use strict';

  function money(cents) {
    try { return '€' + (cents / 100).toFixed(2).replace('.', ','); }
    catch (e) { return ''; }
  }

  function injectStyles() {
    if (document.getElementById('bc-fbt-styles')) return;
    var css = '' +
      '.bc-fbt{margin:22px 0 4px;border:1px solid var(--line,#e4d9c6);background:var(--ivory,#fbf7ef);padding:18px 18px 20px;border-radius:2px;}' +
      '.bc-fbt__head{font-family:var(--sans,Jost,sans-serif);font-size:11px;letter-spacing:.22em;text-transform:uppercase;color:var(--gold-deep,#9a7b2e);margin-bottom:14px;}' +
      '.bc-fbt__rows{display:flex;flex-direction:column;gap:2px;}' +
      '.bc-fbt__row{display:flex;align-items:center;gap:12px;padding:9px 0;border-bottom:1px solid rgba(0,0,0,.06);}' +
      '.bc-fbt__row:last-child{border-bottom:none;}' +
      '.bc-fbt__row input[type=checkbox]{width:17px;height:17px;flex:0 0 auto;accent-color:var(--gold-deep,#9a7b2e);cursor:pointer;}' +
      '.bc-fbt__row input[type=checkbox]:disabled{cursor:default;opacity:.7;}' +
      '.bc-fbt__thumb{flex:0 0 auto;width:46px;height:46px;overflow:hidden;background:var(--cream-2,#eee5d5);border-radius:2px;}' +
      '.bc-fbt__thumb img{width:100%;height:100%;object-fit:cover;display:block;}' +
      '.bc-fbt__mid{flex:1 1 auto;min-width:0;}' +
      '.bc-fbt__name{font-family:var(--body,Jost,sans-serif);font-size:14px;color:var(--text,#2c1b12);line-height:1.3;}' +
      '.bc-fbt__name em{font-style:normal;color:var(--text-dim,#6b5a4a);font-size:12px;}' +
      '.bc-fbt__cat{font-family:var(--sans,sans-serif);font-size:9.5px;letter-spacing:.16em;text-transform:uppercase;color:var(--gold-deep,#9a7b2e);margin-bottom:2px;}' +
      '.bc-fbt__vsel{margin-top:5px;font-family:var(--body,sans-serif);font-size:12.5px;padding:3px 6px;border:1px solid var(--line,#e4d9c6);background:#fff;color:var(--text,#2c1b12);max-width:150px;}' +
      '.bc-fbt__price{flex:0 0 auto;font-family:var(--body,sans-serif);font-size:14px;color:var(--text,#2c1b12);}' +
      '.bc-fbt__summary{margin:16px 0 14px;font-family:var(--body,sans-serif);font-size:15px;color:var(--text,#2c1b12);min-height:22px;}' +
      '.bc-fbt__summary s{color:var(--text-dim,#6b5a4a);text-decoration:line-through;margin-right:8px;}' +
      '.bc-fbt__summary b{color:var(--gold-deep,#9a7b2e);}' +
      '.bc-fbt__save{display:inline-block;margin-left:8px;font-size:12.5px;color:var(--gold-deep,#9a7b2e);}' +
      '.bc-fbt__add[disabled]{opacity:.55;cursor:not-allowed;}';
    var s = document.createElement('style');
    s.id = 'bc-fbt-styles';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function init(root) {
    if (root.__fbtReady) return;
    root.__fbtReady = true;

    var dataEl = root.querySelector('[data-bc-fbt-data]');
    var rowsEl = root.querySelector('[data-bc-fbt-rows]');
    var sumEl = root.querySelector('[data-bc-fbt-summary]');
    var addBtn = root.querySelector('[data-bc-fbt-add]');
    if (!dataEl || !rowsEl || !addBtn) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var comps = (data.companions || []).filter(function (c) {
      return c.variants && c.variants.some(function (v) { return v.available; });
    });
    if (!comps.length) { root.style.display = 'none'; return; }

    // Per-companion state: {checked, variant}
    var state = comps.map(function (c, idx) {
      var firstAvail = c.variants.filter(function (v) { return v.available; })[0];
      return { checked: idx < 2, variant: firstAvail };
    });

    // ---- Current product row (always included) ----
    var curRow = document.createElement('div');
    curRow.className = 'bc-fbt__row bc-fbt__row--current';
    curRow.innerHTML =
      '<input type="checkbox" checked disabled aria-label="This item">' +
      '<span class="bc-fbt__thumb">' + (data.current.image ? '<img src="' + data.current.image + '" alt="">' : '') + '</span>' +
      '<span class="bc-fbt__mid"><span class="bc-fbt__name">' + data.current.title + ' <em>(this item)</em></span></span>' +
      '<span class="bc-fbt__price">' + money(data.current.price) + '</span>';
    rowsEl.appendChild(curRow);

    // ---- Companion rows ----
    comps.forEach(function (c, idx) {
      var row = document.createElement('div');
      row.className = 'bc-fbt__row';

      var cb = document.createElement('input');
      cb.type = 'checkbox';
      cb.checked = state[idx].checked;
      cb.setAttribute('aria-label', 'Add ' + c.title);

      var thumb = document.createElement('span');
      thumb.className = 'bc-fbt__thumb';
      thumb.innerHTML = c.image ? '<img src="' + c.image + '" alt="">' : '';

      var mid = document.createElement('span');
      mid.className = 'bc-fbt__mid';
      var midHtml = '<span class="bc-fbt__cat">' + (c.cat || '') + '</span>' +
        '<span class="bc-fbt__name">' + c.title + '</span>';
      mid.innerHTML = midHtml;

      // colour / variant picker when more than one available variant
      var avail = c.variants.filter(function (v) { return v.available; });
      if (avail.length > 1) {
        var sel = document.createElement('select');
        sel.className = 'bc-fbt__vsel';
        avail.forEach(function (v) {
          var o = document.createElement('option');
          o.value = v.id;
          o.textContent = v.title;
          sel.appendChild(o);
        });
        sel.value = state[idx].variant.id;
        sel.addEventListener('change', function () {
          state[idx].variant = avail.filter(function (v) { return String(v.id) === sel.value; })[0];
          priceEl.textContent = money(state[idx].variant.price);
          recalc();
        });
        mid.appendChild(sel);
      }

      var priceEl = document.createElement('span');
      priceEl.className = 'bc-fbt__price';
      priceEl.textContent = money(state[idx].variant.price);

      cb.addEventListener('change', function () { state[idx].checked = cb.checked; recalc(); });

      row.appendChild(cb);
      row.appendChild(thumb);
      row.appendChild(mid);
      row.appendChild(priceEl);
      rowsEl.appendChild(row);
    });

    function tierFor(count) { return count >= 3 ? 0.2 : (count === 2 ? 0.1 : 0); }

    function recalc() {
      var chosen = state.filter(function (s) { return s.checked && s.variant; });
      var count = 1 + chosen.length;
      var total = data.current.price + chosen.reduce(function (a, s) { return a + s.variant.price; }, 0);
      var tier = tierFor(count);
      var discounted = Math.round(total * (1 - tier));
      var save = total - discounted;

      if (tier > 0) {
        sumEl.innerHTML = '<s>' + money(total) + '</s><b>' + money(discounted) + '</b>' +
          '<span class="bc-fbt__save">save ' + money(save) + ' (' + Math.round(tier * 100) + '%)</span>';
        addBtn.textContent = 'Add bundle · save ' + Math.round(tier * 100) + '%';
      } else {
        sumEl.innerHTML = 'Add one more piece to save <b>10%</b> — two or more for <b>20%</b>.';
        addBtn.textContent = 'Add to bag';
      }
      addBtn.disabled = false;
      return chosen;
    }

    addBtn.addEventListener('click', function () {
      var chosen = state.filter(function (s) { return s.checked && s.variant; });
      var items = [{ id: data.current.id, quantity: 1 }];
      chosen.forEach(function (s) { items.push({ id: s.variant.id, quantity: 1 }); });
      addBtn.disabled = true;
      var label = addBtn.textContent;
      addBtn.textContent = 'Adding…';
      var addUrl = (window.bcRoutes && window.bcRoutes.add) || '/cart/add.js';
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function () { addBtn.disabled = false; addBtn.textContent = 'Could not add — try again'; });
    });

    recalc();
  }

  function boot() {
    injectStyles();
    document.querySelectorAll('[data-bc-fbt]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', boot);
  }
})();
